import { COMPANY, COMPANY_ACCOUNT, USER_ACCOUNT } from '~/constants/Masterdata';

import { type UUID } from '~/types/common';

import { CustomFieldObject } from '~/models/customData';

export const USERS_WITH_CUSTOM_FIELDS = [
  {
    customFields: [
      CustomFieldObject.create({
        displayName: 'Zufuhrart',
        hardcoded: true,
        id: 'Zufuhrart',
        visibility: CustomFieldObject.VISIBILITY.ALWAYS.KEY,
      }),
    ],
    userId: 'ad191288-cb8f-4c87-96f2-131aa9f43db1', // vestigas-support-eireiner@vestigas.com
  },
  {
    customFields: [
      CustomFieldObject.create({
        displayName: 'Zufuhrart',
        hardcoded: true,
        id: 'Zufuhrart',
        visibility: CustomFieldObject.VISIBILITY.ALWAYS.KEY,
      }),
    ],
    userId: 'bb56ca3b-80e0-47f9-83e4-bc5a0bfa2fac', // baumann.philip@anton-eireiner.de
  },
] as const;

export const STRABAG_SUPPORT_USERS = [
  'd0ca33e3-54b3-4c14-a8af-3fd81eb92fa3',
] as const;

export const SUPPLIER_OVERVIEW_USER = [
  '2c2908af-ca68-4fb9-9bc2-2e034bcf19c2',
  'befc3a91-e8be-42f7-9559-16a8cd9cc3e8',
];

export const BAYWA_SCREEN_USER = '018df28e-5247-428f-8ca1-0e79865a3da9';

export const VESTIGAS_ACCOUNTS = [
  USER_ACCOUNT.DEMO_LIEFERANT,
  USER_ACCOUNT.DEMO_POLIER,
  USER_ACCOUNT.DEMO_SPEDITEUR,
  USER_ACCOUNT.LIEFERANT_DEV,
  USER_ACCOUNT.LIEFERANT_IDP,
  USER_ACCOUNT.MUSTER_POLIER,
  USER_ACCOUNT.POLIER_DEV,
  USER_ACCOUNT.SALES_BENEDIKT,
  USER_ACCOUNT.SALES_BENJAMIN,
  USER_ACCOUNT.SALES_DANIEL,
  USER_ACCOUNT.SALES_DIMA,
  USER_ACCOUNT.SALES_ENRICO,
  USER_ACCOUNT.SALES_JASMIN,
  USER_ACCOUNT.SALES_JULIAN,
  USER_ACCOUNT.SALES_MARTIN,
  USER_ACCOUNT.SALES_MORITZ_G,
  USER_ACCOUNT.SALES_MORITZ_K,
  USER_ACCOUNT.SALES_NATALIYA,
  USER_ACCOUNT.SPEDITEUR_DEV,
] as const;

export const SCHICKER_COMPANY_ACCOUNTS = [COMPANY_ACCOUNT.SCHICKER] as const;

export const DLN_DATE_COMPANY_ACCOUNTS = [
  COMPANY_ACCOUNT.SCHICKER,
  COMPANY_ACCOUNT.JOSEF_RAEDLINGER,
  COMPANY_ACCOUNT.STAATLICHES_BAUAMT_BAYREUTH,
] as const;

export const STRABAG_COMPANY_ACCOUNTS = [COMPANY_ACCOUNT.STRABAG] as const;

export const ANBS_COMPANIES = [COMPANY.ANBS];

export const DEMO_ALLOWED_COMPANY_ACCOUNTS = [
  COMPANY_ACCOUNT.DEMO_ALLOWED_01,
  COMPANY_ACCOUNT.DEMO_ALLOWED_02,
  COMPANY_ACCOUNT.DEMO_ALLOWED_03,
  COMPANY_ACCOUNT.DEMO_ALLOWED_04,
  COMPANY_ACCOUNT.DEMO_ALLOWED_05,
  COMPANY_ACCOUNT.DEMO_ALLOWED_06,
  COMPANY_ACCOUNT.DEMO_ALLOWED_07,
  COMPANY_ACCOUNT.DEMO_ALLOWED_08,
  COMPANY_ACCOUNT.DEMO_ALLOWED_09,
  COMPANY_ACCOUNT.DEMO_ALLOWED_10,
  COMPANY_ACCOUNT.DEMO_ALLOWED_11,
  COMPANY_ACCOUNT.DEMO_ALLOWED_12,
  COMPANY_ACCOUNT.DEMO_ALLOWED_13,
  COMPANY_ACCOUNT.DEMO_ALLOWED_14,
  COMPANY_ACCOUNT.DEMO_ALLOWED_15,
  COMPANY_ACCOUNT.DEMO_ALLOWED_16,
  COMPANY_ACCOUNT.DEMO_ALLOWED_17,
  COMPANY_ACCOUNT.DEMO_ALLOWED_18,
] as const;

// Temporary function since some large class components (which will be refactored later) cannot use React hooks
export const isANBSAccount = (companyId: UUID) => {
  return ANBS_COMPANIES.includes(companyId);
};
